import { render, staticRenderFns } from "./business_users.vue?vue&type=template&id=83879f20&scoped=true&"
import script from "./business_users.vue?vue&type=script&lang=js&"
export * from "./business_users.vue?vue&type=script&lang=js&"
import style0 from "./business_users.vue?vue&type=style&index=0&id=83879f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83879f20",
  null
  
)

export default component.exports